let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aC90a")).then(() => parcelRequire('ljJMk'));